import Component from "gia/Component";
import { AddToCart } from "../components/CartEvents.js";
import Channels from "../base/channels";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.form = this.DOM.view.querySelector('form[action$="/cart/add"]');
    if (typeof this.ref.btnAdd != "undefined") {
      this.DOM.btnAdd = this.ref.btnAdd;
    }

    //
    this.disableButton();
    this.events();
  }

  disableButton() {
    if (typeof this.DOM.btnAdd != "undefined") {
      for (let btn of this.DOM.btnAdd) {
        btn.disabled = true;
      }
    }
  }

  events() {
    if (typeof this.DOM.btnAdd != "undefined") {
      for (let btn of this.DOM.btnAdd) {
        btn.addEventListener("click", () => {
          const data = new FormData(this.DOM.form);
          // for (let [k, v] of data.entries()) {
          //   console.log(k, v);
          // }
          AddToCart(data, false);
        });
      }
    }

    Channels.addListener("bundle::ready", () => {
      for (let btn of this.DOM.btnAdd) {
        btn.disabled = false;
      }
    });
    Channels.addListener("bundle::adding", () => {
      for (let btn of this.DOM.btnAdd) {
        btn.disabled = true;
      }
    });
  }

  unmount() {}
}
